import { FetchProcedureByUserCommand } from '@/Application/Procedures/FetchProcedureByUserCommand'
import { ProcedureId, UserProcedureRepository } from '@/Domain/Procedures'
import { ProcedureDto } from '@/Application/Procedures/ProcedureDto'
import { BatchRepository } from '@/Domain/Batch'
import { BatchDto, ProcedureBatchesDto } from '../Batch'

export class FetchProcedureByUserCommandHandler {
  private _procedureRepository: UserProcedureRepository
  private _batchRepository: BatchRepository

  constructor (procedureRepository: UserProcedureRepository, batchRepository: BatchRepository) {
    this._procedureRepository = procedureRepository
    this._batchRepository = batchRepository
  }

  async handle (command: FetchProcedureByUserCommand): Promise<ProcedureBatchesDto> {
    const procedureId = new ProcedureId(command.procedureId())
    const procedure = await this._procedureRepository.byUserbyId(command.accountId(), procedureId)
    const response = await this._batchRepository.byProcedureIdAndUserIdWithOffers(procedureId, command.accountId())
    const formattedResponse = {
      procedure: ProcedureDto.fromProcedure(procedure),
      batches: {
        RESUL: [] as BatchDto[],
        RISCO: [] as BatchDto[]
      }
    }
    for (const batch of response) {
      formattedResponse.batches[batch.batchType()].push(BatchDto.fromBatch(batch))
    }
    return formattedResponse
  }
}
